import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  CreateFormBuilderFieldCommand,
  FormBuilderFieldTypes,
  UpdateFormBuilderFieldCommand,
} from 'src/app/core/api/models';
import { FormBuilderFieldsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormFieldsValidationsComponent } from '../../base/form-fields-validations/form-fields-validations.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { DropDownFieldsComponent } from './drop-down-fields/drop-down-fields.component';

@Component({
  selector: 'app-fields-management-form',
  templateUrl: './fields-management-form.component.html',
  imports: [
    BaseFormModule,
    DropDownFieldsComponent,
    FormFieldsValidationsComponent,
  ],
})
export class FieldsManagementFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  @Input() isModalMode: boolean = false;

  formPageConfig: FormPageConfig<any> = {};
  model: CreateFormBuilderFieldCommand = {};
  newDropDownModel: string[] = [];
  createDropDownForms: FormGroup[] = [];
  isShowSelectList: boolean = false;

  @Output() isCloseModal = new EventEmitter<boolean>();

  get FormBuilderFieldTypes() {
    return FormBuilderFieldTypes;
  }

  //#endregion

  constructor(private currentService: FormBuilderFieldsService) {
    super();
  }

  ngOnInit() {
    this.formPageConfig.vocabs = 'pages.fieldsManagement.form.';
    super.ngOnInit();
  }

  initModel(): void {
    try {
      super.initModel();
      this.changeFieldType();
      if (!this.model.validation) this.model.validation = {};

      if (this.formPageConfig.isEditMode) {
        this.newDropDownModel = Object.assign([], this.model.selectListOptions);
      } else {
        this.newDropDownModel = [];
        this.onAddOption();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  onAddOption() {
    try {
      this.newDropDownModel.push('');
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      fieldType: new FormControl('', Validators.required),
      isRequired: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateFormBuilderFieldCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .formBuilderFieldsCreate({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateFormBuilderFieldCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .formBuilderFieldsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onRemoveOption(index: number) {
    try {
      if (this.newDropDownModel.length > 1 || this.formPageConfig.isEditMode)
        this.newDropDownModel.splice(index, 1);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  override onSubmit() {
    this.model.selectListOptions = this.newDropDownModel;
    if (this.loading) return;
    if (!this.isValidForm(this.form, this.tagName)) return;

    try {
      this.checkCreateOrUpdate();
    } catch (error) {
      ConsoleService.error('error', error);
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  override onSuccess() {
    if (!this.isModalMode) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'instant',
      });

      this.output_closeFormPage.emit(true);
      this.unSubs();
    } else this.isCloseModal.emit(true);
  }

  override onClose() {
    if (!this.isModalMode) {
      this.loading = false;
      this.formPageConfig.isEditMode = false;
      this.output_closeFormPage.emit(false);

      window.scroll({
        top: 0,
        left: 0,
        behavior: 'instant',
      });

      this.unSubs();
    } else this.isCloseModal.emit(false);
  }

  hideValidationFields() {
    this.isShowSelectList = false;
  }

  changeFieldType() {
    this.hideValidationFields();
    switch (this.model.fieldType) {
      case FormBuilderFieldTypes.SelectList:
        this.isShowSelectList = true;
        break;
    }
  }
}
